import React from 'react';
import { Handle, Position } from 'reactflow';
import { MessageSquare, MapPin, Clock } from 'lucide-react';

const WaitForResponseNode = ({ data, selected }) => {
  const responseType = data.response_type || 'location';
  const timeoutHours = data.timeout_hours || 24;
  
  const getResponseIcon = () => {
    switch (responseType) {
      case 'location':
        return <MapPin className="w-4 h-4" />;
      case 'text':
        return <MessageSquare className="w-4 h-4" />;
      default:
        return <MessageSquare className="w-4 h-4" />;
    }
  };
  
  const getResponseLabel = () => {
    switch (responseType) {
      case 'location':
        return 'Location Pin';
      case 'text':
        return 'Text Reply';
      default:
        return 'Response';
    }
  };

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 min-w-[180px] shadow-lg ${
        selected
          ? 'border-cyan-400 bg-cyan-500/20'
          : 'border-cyan-500/50 bg-slate-800/90'
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="w-3 h-3 !bg-cyan-400"
      />
      
      <div className="flex items-center gap-2 mb-2">
        <div className="p-1.5 rounded-md bg-cyan-500/20">
          <MessageSquare className="w-4 h-4 text-cyan-400" />
        </div>
        <span className="text-xs font-medium text-cyan-400 uppercase tracking-wide">
          Wait
        </span>
      </div>
      
      <div className="text-sm font-medium text-white truncate">
        {data.label || 'Wait for Response'}
      </div>
      
      <div className="flex items-center gap-2 mt-2 text-xs text-slate-400">
        <div className="flex items-center gap-1">
          {getResponseIcon()}
          <span>{getResponseLabel()}</span>
        </div>
      </div>
      
      <div className="flex items-center gap-1 mt-1 text-xs text-slate-500">
        <Clock className="w-3 h-3" />
        <span>Timeout: {timeoutHours}h</span>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        id="received"
        className="w-3 h-3 !bg-green-400"
        style={{ left: '30%' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="timeout"
        className="w-3 h-3 !bg-red-400"
        style={{ left: '70%' }}
      />
      
      <div className="flex justify-between text-[10px] text-slate-500 mt-1 px-1">
        <span>Received</span>
        <span>Timeout</span>
      </div>
    </div>
  );
};

export default WaitForResponseNode;
